<template>
  <div >
    <van-cell-group class="body kuang">
      <van-cell
        v-if="list.province"
        title="地区"
        :value="`${list.province || ''}${list.city || ''}${list.district || ''}`"
      />
      <van-cell
        v-if="list.levelSGWDirector"
        title="本级少工委主任人数"
        :value="list.levelSGWDirector + '人'"
      />
      <van-cell
        v-if="list.levelSGWDirectorName"
        title="本级少工委主任姓名"
        :value="list.levelSGWDirectorName"
      />
      <van-cell
        v-if="list.levelSGWDirectorJob"
        title="本级少工委主任身份"
        :value="format(list.levelSGWDirectorJob, 7)"
      />
      <van-cell
        v-if="list.levelSGWDirectorJobOther"
        title="本级少工委主任职务"
        :value="list.levelSGWDirectorJobOther"
      />
      <van-cell
        v-if="list.levelSGWDirectorName2"
        title="本级少工委主任姓名"
        :value="list.levelSGWDirectorName2"
      />
      <van-cell
        v-if="list.levelSGWDirectorJob2"
        title="本级少工委主任身份"
        :value="format(list.levelSGWDirectorJob2, 7)"
      />
       <van-cell
        v-if="list.levelSGWDirectorJobOther2"
        title="本级少工委主任职务"
        :value="list.levelSGWDirectorJobOther2"
      />
      <van-cell
        v-if="list.sdhsj"
        title="本届少代会召开时间"
        :value="format(list.sdhsj, 6)"
      />
      <van-cell
        v-if="list.levelOutsideCounselorsNum"
        title="本级校外辅导员资源库人数"
        :value="list.levelOutsideCounselorsNum + '人'"
      />

      <van-cell
        v-if="list.levelCounselors"
        title="是否配备总辅导员"
        :value="format(list.levelCounselors, 1)"
      />
      <div v-if="list.levelCounselors == 1">
        <van-cell v-if="list.name" title="姓名" :value="list.name" />
        <van-cell v-if="list.sex" title="性别" :value="format(list.sex, 12)" />
        <van-cell
          v-if="list.birthday"
          title="出生日期"
          :value="format(list.birthday, 6)"
        />
        <van-cell
          v-if="list.employmentTime"
          title="担任总辅导员时间"
          :value="format(list.employmentTime, 6)"
        />
        <van-cell v-if="list.edu" title="学历" :value="format(list.edu, 13)" />
        <van-cell v-if="list.zzmm" title="政治面貌" :value="format(list.zzmm, 2)" />
        <van-cell v-if="list.tel" title="手机号" :value="list.tel" />
        <van-cell
          v-if="list.company"
          title="编制所在单位"
          :value="format(list.company, 8)"
        />
        <van-cell
          v-if="list.company == 7"
          title="其他编制"
          :value="list.companyOther"
        />
        <van-cell
          v-if="list.administrationLevel"
          title="行政级别"
          :value="format(list.administrationLevel, 9)"
        />
        <van-cell
          v-if="list.postType"
          title="岗位类型"
          :value="format(list.postType, 10)"
        />
      </div>
    </van-cell-group>
  </div>
</template>
<script>
import { format } from "@/common/js/utils";
export default {
  props: {
    list: Object,
  },
  setup() {
    return { format };
  },
};
</script>
<style lang="less" scoped>
.body {
  margin-bottom: 1.53333rem;
}
</style>
